import type { FilterSeparator } from '@sorare/core/src/lib/filters';

export const filterSeparator: FilterSeparator = { type: 'separator' };
export {
  RefineActiveNationalTeam,
  RefineActiveLeague,
  RefineCardEdition,
  RefinePlayer,
  RefineSeason,
  RefineSingleYearSeason,
  RefinePlayingStatus,
  RefineNationality,
  RefineBirthplace,
} from './RefineList/index.tsx';
export { RefineCardPlayerAge } from './RefineAge/index.tsx';
export {
  RefineCardLevel,
  RefineBackendCardLevel,
} from './RangeSlider/index.tsx';
export {
  RefineAverageScore,
  RefineBackendAverageScore,
} from './RefineAverageScore/index.tsx';
export { RefineAppearances } from './RefineAppearances/index.tsx';
export {
  RefineSerialNumber,
  RefineBackendSerialNumber,
} from './RefineSerialNumber/index.tsx';
export {
  widget as RefineCompetitionEligibility,
  BackendRefineCompetitionEligibility,
} from './RefineCompetitionEligibility/index.tsx';

export {
  widget as NotInLineupFilter,
  backendWidget as BackendNotInLineupFilter,
} from './NotInLineupFilter/index.tsx';
export {
  widget as CollectibleFilter,
  backendWidget as BackendCollectibleFilter,
} from './CollectibleFilter/index.tsx';
export {
  GameweekFilter,
  DailyFilter,
  BackendGameweekFilter,
  BackendDailyFilter,
} from './FixtureFilter/index.tsx';
export {
  widget as RefineOnSale,
  backendWidget as BackendRefineOnSale,
} from './RefineOnSale/index.tsx';
export { widget as RefineCreditEligible } from './RefineCreditEligible/index.tsx';
export { AdvancedCardSearch } from './AdvancedCardSearch/index.tsx';
export {
  widget as PromotionalEventFilter,
  PromotionalEventFilterForInstantBuy,
} from './PromotionalEventFilter/index.tsx';
export {
  widget as RefineInSeason,
  backendWidget as BackendRefineInSeason,
} from './RefineInSeason/index.tsx';
export {
  AcceptedCurrencyGroup,
  BackendAcceptedCurrencyGroup,
  BackendWatchlistGroup,
  CollectibleGroup,
  PriceGroup,
  RarityGroup,
  SaleGroup,
} from './refineGroups.tsx';
export {
  RefinePosition,
  RefineBackendPosition,
} from './RefinePosition/index.tsx';
export { widget as BidToEarnFilter } from './BidToEarnFilter/index.tsx';
export { BackendRevealableCardCampaignMenu } from './RevealableCardCampaignMenu/index.tsx';
